if (!customElements.get('the-system')) {
  class TheSystem extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.swatches = this.querySelectorAll('.js-swatch');
      this.mainImage = this.querySelector('.js-main-image');
      this.mainTitle = this.querySelector('.js-main-title');
      this.mainDescription = this.querySelector('.js-main-description');

      this.swatches.forEach(swatch => {
        swatch.addEventListener('click', this.onSwatchClick.bind(this));
      });
    }

    onSwatchClick(event) {
      const swatch = event.currentTarget;
      const newSrc = swatch.dataset.imageSrc;
      const newSrcset = swatch.dataset.imageSrcset;
      const newTitle = swatch.dataset.title;
      const newDescription = swatch.dataset.description;

      // Update image
      if (this.mainImage && newSrc) {
        this.mainImage.style.opacity = '0.3';
        setTimeout(() => {
          this.mainImage.src = newSrc;
          this.mainImage.srcset = newSrcset;
          this.mainImage.style.opacity = '1';
        }, 200);
      }

      // Update title
      if (this.mainTitle && newTitle !== undefined) {
        this.mainTitle.style.opacity = '0.3';
        setTimeout(() => {
          this.mainTitle.textContent = newTitle;
          this.mainTitle.style.opacity = '1';
        }, 200);
      }

      // Update description
      if (this.mainDescription && newDescription !== undefined) {
        this.mainDescription.style.opacity = '0.3';
        setTimeout(() => {
          this.mainDescription.textContent = newDescription;
          this.mainDescription.style.opacity = '1';
        }, 200);
      }

      this.swatches.forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');
    }
  }

  customElements.define('the-system', TheSystem);
}
